// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxList from './checkbox-list';
import {FormattedMessage} from 'react-intl';

const CheckboxListWithLabel = props =>
    <section className={props.className}>
        <h3 className={props.isRequired ? 'asterisk-after form-group-title' : 'optional-section form-group-title'}>
            <FormattedMessage id={props.label}/>
        </h3>
        <CheckboxList
            canUseDefaultFormat={props.canUseDefaultFormat}
            initialState={props.initialState}
            list={props.list}
            onChange={props.onChange}
            uid={props.uid}
        />
    </section>;

CheckboxListWithLabel.displayName = 'CheckboxListWithLabel';
CheckboxListWithLabel.propTypes = {
    canUseDefaultFormat: PropTypes.bool,
    className: PropTypes.string.isRequired,
    initialState: PropTypes.object.isRequired,
    isRequired: PropTypes.bool,
    label: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    uid: PropTypes.string.isRequired
};

export default CheckboxListWithLabel;



// WEBPACK FOOTER //
// ./src/shared/components/checkbox-list-with-label/index.js